import React from 'react';
import '../styles/Skills.css';

const Skills = () => {
  const skills = ['Java', 'SQL/SQL Server', 'JavaScript', 'React', 'Python', 'C/C++/C#', 'Perl', 'Unix/Linux', 'Docker', 'Azure', 'AWS', 'Shell', 'Spring', '.NET Core', 'REST', 'Climbing rocks', 'Running in circles', 'And many more useful things...'];

  return (
    <section id="skills" className="skills-section">
      <h2>Skills</h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {skills.map((skill, index) => (
          <li key={index} style={{ margin: '0.5rem 0', fontFamily: 'Georgia' }}>
            🌿 {skill}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Skills;
